<template>
  <div>
    <div class="logo">
      <div class="logoIcon">
        <IconBase
          icon-name="logo-icon"
          iconColor="#444"
          viewBox="83.799 83.799 821.229 821.229"
          width="100%"
          height="100%"
          strokeWidth="0px"
          ><LogoIconBlack
        /></IconBase>
      </div>
      <div class="logoText">
        <IconBase
          icon-name="logo-text"
          iconColor="#444"
          viewBox="1072.626 310.056 2011.173 376.864"
          width="100%"
          height="100%"
          strokeWidth="0px"
          ><LogoTextBlack
        /></IconBase>
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from "./IconBase";
import LogoIconBlack from "./LogoIconBlack";
import LogoTextBlack from "./LogoTextBlack";

export default {
  name: "CalendarNav",
  components: {
    IconBase,
    LogoIconBlack,
    LogoTextBlack,
  },
};
</script>

<style scoped>
.logo {
  /* height: 30px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 12px;
  transform: scale(7);
  margin-top: 30px;
}
.logoIcon {
  width: 24px;
  height: 24px;
}

.logoText {
  height: 13px;
  width: 78px;
}
.logoContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>